import { Card, Divider } from 'antd';
import { EnvironmentOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';

export const ContactInfo = () => {
  const sites = [
    {
      title: 'CES – Elizabeth',
      address: '141 North Ave, Elizabeth, NJ 07201',
      phone: '908-838-7028',
      hours: '8am – 5pm (Closed for lunch from 12 to 1 PM)',
      email: 'CES@eastcoastwarehouse.com',
    },
    {
      title: 'CES – Philadelphia',
      address: '3433 Moore St, Philadelphia, PA 19145',
      phone: '215-309-0676',
      hours: '8am – 3:30pm',
      email: 'PHLCES@eastcoastwarehouse.com',
    },
    {
      title: 'CES - Baltimore',
      address: '6151 Cold Mill Road, Sparrows Point, MD 21219',
      phone: '443-423- 1691',
      hours: '8am – 5pm (Closed for lunch from 12 to 1 PM)',
      email: 'BWI-CES@eastcoastwarehouse.com',
    },
  ];
  return (
    <Card
      title='Contact Information'
      style={{
        borderRadius: '10px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        backgroundColor: '#f0f2f5',
        color: '#333',
      }}
    >
      {sites.map((site) => (
        <div key={site.address}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <EnvironmentOutlined style={{ fontSize: '24px', marginRight: '10px', color: '#1890ff' }} />
            <div>
              <h3 style={{ marginBottom: '0' }}>{site.title}</h3>
              <p style={{ margin: '0' }}>{site.address}</p>
            </div>
          </div>
          <Divider style={{ margin: '10px 0' }} />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <PhoneOutlined style={{ fontSize: '24px', marginRight: '10px', color: '#1890ff' }} />
            <div>
              <p style={{ margin: '0' }}>
                Phone:{' '}
                <a href={'tel:' + site.phone} style={{ color: '#1890ff' }}>
                  {site.phone}
                </a>
              </p>
              <p style={{ margin: '0' }}>Hours: {site.hours}</p>
            </div>
          </div>
          <Divider style={{ margin: '10px 0' }} />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <MailOutlined style={{ fontSize: '24px', marginRight: '10px', color: '#1890ff' }} />
            <div>
              <p style={{ margin: '0' }}>
                Email:{' '}
                <a href={'mailto:' + site.email} style={{ color: '#1890ff' }}>
                  {site.email}
                </a>
              </p>
            </div>
          </div>
          <Divider style={{ margin: '10px 0', color: 'black' }} />
        </div>
      ))}
    </Card>
  );
};
